<template>
  <div>redirecting..</div>
</template>
<script>
export default {
  name: 'ReferralCode.vue',
  mounted() {
    sessionStorage.setItem('referralCode', this.$route.params.code)
    this.$router.push({ name: 'page-register' })
  }
}
</script>

<style scoped></style>
